import request from '@/utils/request';

//文件夹列表
export const folderList = () => {
    return request.post('/category/lists')
}


//模型列表
export const modelList = ({page, pageSize=20, categoryId}) => {
    return request.post('/gem/page', {
        page,
        pageSize,
        categoryId
    })
}

//模型详细信息
export const modelDtails = (id) => {
    return request.post('/gem/detail',{
        id
    })
}